module.exports = "/_next/static/images/69d78ad92608100dd7fca5435c27d244-footer-sic-4x.png";